import { Component } from 'preact';
import Hammer from 'hammerjs';

import 'normalize.css';
import './style/main.scss';

import Song from './components/song';
import Backdrop from './components/backdrop';

import HeadStuff from './head-stuff';
import backgroundColors from './constants/colors';
import { getAppropriateColor, getRandomIntInclusive, shuffleArray } from './helpers';

const songsJSON = require('./data/songs.json');

const songs = songsJSON.map((songFromJSON) => {
  const {
    credits, id, title, verses,
  } = songFromJSON;
  const randomIndex = getRandomIntInclusive(0, backgroundColors.length - 1);
  const backgroundColor = backgroundColors[randomIndex];
  const attributes = {
    backgroundColor,
    color: getAppropriateColor(backgroundColor),
    credits,
    key: id,
    title,
    verses,
  };
  return <Song {...attributes} />;
});

// Shuffle the songs
shuffleArray(songs);

export default class App extends Component {
  state = {
    animating: false,
    doneSong: false,
    savingSong: false,
    songIndex: 0,
  };

  componentDidMount() {
    const hammertime = new Hammer(this.base);
    hammertime.on('swipeleft', this.handleSongDone);
    hammertime.on('swiperight', this.handleSongSaved);
  }

  handleSongDone = () => {
    let { songIndex } = this.state;
    if (songIndex <= songs.length) {
      this.setState({
        animating: true,
        doneSong: true,
        savingSong: false,
        songIndex: (songIndex += 1),
      });
      // Allow time for animation to finish.
      // Manually synced with animation duration.
      setTimeout(() => {
        this.setState({
          animating: false,
        });
      }, 500);
    }
  };

  handleSongSaved = () => {
    let { songIndex } = this.state;
    if (songIndex < songs.length) {
      this.setState({
        animating: true,
        doneSong: false,
        savingSong: true,
        songIndex: (songIndex += 1),
      });
      setTimeout(() => {
        this.setState({
          animating: false,
        });
        setTimeout(() => {
          this.saveSong(songs[songIndex - 1]);
        }, 0);
      }, 500);
    }
  };

  saveSong = (savedSong) => {
    savedSong.attributes.saving = false;
    songs.push(savedSong);
  };

  render() {
    const {
      animating, doneSong, savingSong, songIndex,
    } = this.state;
    const currentSong = songs[songIndex] || <Backdrop />;
    const previousSong = songs[songIndex - 1] || null;
    if (previousSong) {
      const previousSongAttributes = previousSong.attributes;
      previousSong.attributes = {
        ...previousSongAttributes,
        done: doneSong,
        saving: savingSong,
      };
    }
    return (
      <div className="wrapper">
        <HeadStuff />
        {animating && previousSong}
        {currentSong}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./index.js